import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AppName } from '@equine-ui-nx/ui';

@Component({
  selector: 'account-not-verify-form',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './account-not-verify.component.html',
  styleUrl: './account-not-verify.component.scss',
})
export class AccountNotVerifyFormComponent implements OnInit{
  @Input() appName!: string;
  @Output('navigateToSignupVerify') navigateToSignupVerifyEvent = new EventEmitter<void>();
  logoUrl = ``
  backgroundImageId = ``
  ngOnInit(): void {
      if(this.appName == AppName.ARENA_EQ){
      this.backgroundImageId = 'intro-arena'
      this.logoUrl = `assets/images/arenaEq-logo.png`
    }else{
      this.logoUrl = `../../../assets/images/access-logo-full.png`
      this.backgroundImageId = 'intro-iea'
    }
  }
  navigateToSignupVerify() {
    this.navigateToSignupVerifyEvent.emit();
  }

}
